import styled from 'styled-components'
import { Tooltip } from 'antd'
import { colours } from '@qflow/theme'
import { ChevronDown } from 'portal/lib/primitives/icons'

export function SideBarGroup({
  children,
  groupName = '',
  groupIcon = null,
  active = false,
  disabled = false,
  UpgradeToProComponent = null
}) {
  if (disabled && !UpgradeToProComponent) {
    return (
      <DisabledGroup>
        <div>
          <Tooltip
            title="Feature not enabled for this Project"
            placement="right"
          >
            <SummaryLeft>
              <GroupIcon>{groupIcon}</GroupIcon>
              <div>{groupName}</div>
            </SummaryLeft>
          </Tooltip>
        </div>
      </DisabledGroup>
    )
  } else if (disabled && UpgradeToProComponent) {
    return (
      <DisabledGroup>
        <div>
          <SummaryLeft>
            <GroupIcon>{groupIcon}</GroupIcon>
            <div>{groupName}</div>
          </SummaryLeft>
          {UpgradeToProComponent && <UpgradeToProComponent />}
        </div>
      </DisabledGroup>
    )
  }

  return (
    <StyledDetails open={active} active={active} disabled={disabled}>
      <summary>
        <SummaryLeft>
          <GroupIcon>{groupIcon}</GroupIcon>
          <div>{groupName}</div>
        </SummaryLeft>
        <ChevronDown size={'12'} />
      </summary>
      {children}
    </StyledDetails>
  )
}

const StyledDetails = styled.details`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  list-style: none;
  font-size: 14px;
  font-weight: 700;
  color: ${({ active, theme }) =>
    active ? `${theme.colours.TEAL} !important` : 'rgba(255,255,255,0.8)'};
  cursor: pointer;
  outline: none;
  user-select: none;
  padding: 0.25rem 1rem 0.25rem 0.75rem;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover {
    color: ${colours.CONTROL_PANEL_GREY};
  }

  &[open] {
    SUMMARY > SVG {
      transform: rotate(180deg) !important;
    }
  }

  & > summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
  }
`

const SummaryLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`

const DisabledGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  list-style: none;
  font-size: 14px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  outline: none;
  user-select: none;
  padding: 0.5rem 1rem 0.5rem 0.75rem;

  & > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.25rem 0;
  }
`
const GroupIcon = styled.div`
  min-width: 20px;
  max-height: 18px;
  text-align: center;
`
